// extracted by mini-css-extract-plugin
export var arrows = "_8k-6";
export var decrementer = "_8k-a";
export var disabled = "_8k-4";
export var error = "_8k-1";
export var hiddenText = "_8k-b";
export var incrementer = "_8k-9";
export var input = "_8k-8";
export var inputWrapper = "_8k-0";
export var leadingIcon = "_8k-c";
export var readonly = "_8k-3";
export var regular = "_8k-7";
export var small = "_8k-5";
export var warning = "_8k-2";